import * as React from "react";
import { makeStyles } from "@material-ui/core";

// components
import { LogoHorizontal } from "@components/logo";

// material-ui
import { Button } from "@material-ui/core";

// constants
import { gcalUrl } from "@clockwise/client-commons/src/constants/site";

// styles
import { zIndexHomeNav } from "@styles/z-index-stack.styles";
import { colors, gradient, greys } from "@styles/color.styles";

export interface NavBarProps {
  primaryButtonText?: string;
  primaryButtonLink?: string;
  secondaryButtonText?: string;
  secondaryButtonLink?: string;
}

const useStyles = makeStyles({
  container: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    zIndex: zIndexHomeNav,
    display: "flex",
    height: 80,
    background: "white",
    borderBottom: `1px solid ${greys.paleGrey}`,
    flexDirection: "column",
    boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.1)",

    "@media (maxWidth: 768px)": {
      boxShadow: "none",
      borderStyle: "solid",
      borderWidth: 0,
      borderBottomWidth: 1,
      borderColor: greys.borderGrey,
    },
  },
  logo: {
    width: 172,
    "@media (maxWidth: 768px)": {
      width: 160,
    },
  },
  logoContainer: {
    padding: "0 20px",
    marginRight: "auto",
    marginLeft: 0,
    height: "100%",
    display: "flex",
    alignItems: "center",
  },
  gradientBar: {
    height: 4,
    width: "100%",
    flexShrink: 0,
    background: gradient,
    display: "none",

    "@media (maxWidth: 768px)": {
      display: "block",
    },
  },
  content: {
    padding: "10px 20px",
    display: "flex",
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
  },
  navButtons: {
    display: "flex",
    "@media (max-width: 610px)": {
      visibility: "hidden",
    },
  },
  secondaryButton: { marginRight: 15, color: greys.slate },
});

export const NavBar = ({
  primaryButtonText = "Go to Calendar",
  primaryButtonLink = gcalUrl,
  secondaryButtonText,
  secondaryButtonLink,
}: NavBarProps) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.gradientBar} />
      <div className={classes.content}>
        <a className={classes.logoContainer}>
          <LogoHorizontal
            fill={colors.blueDusk.darker}
            style={{
              width: 172,
            }}
          />
        </a>
        <div className={classes.navButtons}>
          {secondaryButtonText && secondaryButtonLink && (
            <Button
              href={secondaryButtonLink}
              className={classes.secondaryButton}
              color="secondary"
              target="_blank"
            >
              {secondaryButtonText}
            </Button>
          )}
          <Button variant="contained" href={primaryButtonLink} color="primary" target="_blank">
            {primaryButtonText}
          </Button>
        </div>
      </div>
    </div>
  );
};
